import {ProgramDurationUnitEnum} from './programDurationEnum';

export const MIN_DURATION_FOR_MONTHLY_PAYMENT =
  ProgramDurationUnitEnum.MONTH.multiplier * 2;

export const CLIENT_CONFERENCE_DURATIONS = [15, 30, 45, 60]; // mins

export const EVERGREEN_PROGRAM_DURATION = 30;

export const EVERGREEN_PROGRAM_SCHEDULE_DURATION = 365;
